var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylInvestEducation"}},[(_vm.isMobileScreen)?_c('ylInvestEducationMobile',_vm._b({attrs:{"list":_vm.list}},'ylInvestEducationMobile',_vm.$attrs,false)):_c('ylInvestEducationPC',_vm._b({attrs:{"list":_vm.list}},'ylInvestEducationPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }